module.exports = __webpack_public_path__ + "static/media/ico.b36bf96a.png";